import React from "react";
import { Layout, Spin, Typography } from "antd";

const { Content } = Layout;
const { Title, Text } = Typography;

export function PrintingScreen() {
  return (
    <Layout style={{ minHeight: "100vh", background: "#f5f5f5" }}>
      <Content style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div style={{ textAlign: "center" }}>
          <Spin size="large" />
          <Title level={3} style={{ marginTop: 16 }}>Printing receipt…</Title>
          <Text type="secondary">Please wait</Text>
        </div>
      </Content>
    </Layout>
  );
}